<template>
  <div class="" id="newslist">
    <!--内容-->
    <div class="">
      <v-col v-for="(item, i) in contents" :key="i" :id="item.date">
        <div style="display:flex;">
          <v-card-actions v-if="item.hasButton2">
            <v-btn
              rounded
              outlined
              class="mx-2 top-news"
              v-for="(btn, i) in item.button"
              :key="i"
              :color="btn.color"
              :href="btn.href">
              <!--ボタンの中の文字-->
              {{ btn.text }}
            </v-btn>
          </v-card-actions>
          <v-card-text class="date mt-2" style="padding-bottom:0;">
            {{ item.date }}
          </v-card-text>
        </div>
        <v-card-title class="descriptiontitle">
          {{ item.descriptiontitle }}
        </v-card-title>

        <v-card-text class="summary" style="white-space:pre-wrap; word-wrap:break-word; margin-top:-1rem;">
          <div v-html="item.description "></div>
          <div class="news-pagepath">
            <a :to="item.path">{{ item.label }}</a>
          </div>
          <v-card-actions v-if="item.hasButton">
            <div v-html="item.description2 "></div>
            <v-btn
              rounded
              outlined
              color="primary"
              v-for="(btn, i) in item.button"
              :key="i"
              :href="btn.href"
              style="margin-left:-20px;">
              <v-icon>
                <!--ボタンの中のアイコン-->
                {{ btn.icon }}
              </v-icon>
              <!--ボタンの中の文字-->
              {{ btn.text }}
            </v-btn>
            <v-btn
              rounded
              outlined
              color="primary"
              v-for="(btn, i) in item.button2"
              :key="i"
              :href="btn.href">
              <v-icon class="ml-2">
                <!--ボタンの中のアイコン-->
                {{ btn.icon2 }}
              </v-icon>
              <!--ボタンの中の文字-->
              {{ btn.text2 }}
            </v-btn>
          </v-card-actions>
          <v-card-actions v-if="item.hasLink" class="link-wrap">
            <v-btn
              target="_blank"
              text
              color="blue"
              class="text-link"
              v-for="(btn, i) in item.link"
              :key="i"
              :href="btn.href">
              <!--ボタンの中の文字-->
              {{ btn.text }}
            </v-btn>
          </v-card-actions>
        </v-card-text>
      </v-col>
    </div>
  </div>
</template>

<style>
.subHead {
  font-size: 25px;
}
.head2 {
  font-size: 20px;
  border-left: inset 6px#99CCFF;
  padding-left: 8px;
  margin-bottom: 8px;
}
.summary {
  vertical-align: middle;
  font-size: 16px;
}
.descriptiontitle{
    font-size: 18px;
  color:#345fb5;
}
hr{
    max-width: 1200px;
}

.news-pagepath {
   margin-bottom:1rem;
}

.text-link {
  margin-bottom:-0.5rem;
}

.link-wrap {
  margin-left:-1rem;
  }

.link-wrap .v-btn__content {
  display:block;
  }
.link-wrap .v-text__content {
  display:block;
  }
.link-wrap .v-btn{
  display: block !important;
  white-space: normal !important;
  overflow-wrap: anywhere !important;
  text-transform: none !important;
}
.link-wrap .v-btn + .v-btn{
  margin-left: 0 !important;
}
</style>

<script>
export default {
  data () {
    return {
      // hash: this.$route.date,
      contents: [
        {
          hasButton2: 'true',
          // ボタンの内容
          button: [
            {
              text: 'TopNews!',
              href: '/News#2022-10-21',
              color: 'red'
            }],
          date: '2022-10-21',
          // 説明タイトル
          descriptiontitle: 'JAXA ASTEROID DATA EXPLORER (JADE) の開発で、KonniesystemがAcknowledgmentsに掲載されました。',
          hasLink: 'true',
          // ボタンの内容
          link: [
            {
              text: 'JADEの紹介 (URL: https://jlpeda.jaxa.jp/activity/archive/detail_43/)',
              href: 'https://jlpeda.jaxa.jp/activity/archive/detail_43/'
            }],
          // 説明文
          description: `
JAXA ASTEROID DATA EXPLORER (JADE)は、
はやぶさ2が撮影した小惑星リュウグウの画像を検索閲覧するシステムです。
2Dや3Dで表示させたリュウグウ上で、詳細な条件を指定して該当する画像を抽出することができます。
はやぶさ以外の小惑星や衛星にも利用が検討されています。

掲載されたポスター
JAXA ASTEROID DATA EXPLORER (JADE) FOR ACCESSING AND RETRIEVING HAYABUSA2 ONC IMAGE DATA WITH 2D/3D SWITCHABLE MAPS IN A WEB BROWSER.
Lunar and Planetary Science Conference. 2022. 53. 1779

※JADEは2025年末をもって運用を終了しました。
JADEの紹介は、JAXA 月惑星探査データ解析グループ（JLPEDA）の下記のページでご覧いただけます。`
        },
        {
          date: '2026-10-16',
          // 説明タイトル
          descriptiontitle: '「コニーシステム ホームページラボ」を公開しました',
          hasLink: 'true',
          // ボタンの内容
          link: [
            {
              text: 'コニーシステム ホームページラボ (URL: https://hp.konniesystem.co.jp/)',
              href: 'https://hp.konniesystem.co.jp/'
            }],
          // 説明文
          description: `
このたび、当社の「コニーシステム ホームページラボ」サイトを公開しました。`
        },
        {
          date: '2026-10-16',
          // 説明タイトル
          descriptiontitle: '「コニーシステム AIラボ」を公開しました',
          hasLink: 'true',
          // ボタンの内容
          link: [
            {
              text: 'コニーシステム AIラボ (URL: https://ai.konniesystem.co.jp/)',
              href: 'https://ai.konniesystem.co.jp/'
            }],
          // 説明文
          description: `
このたび、当社の「コニーシステム AIラボ」サイトを公開しました。`
        },
        {
          date: '2026-08-06',
          // 説明タイトル3
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2026年8月11日(火) ～ 2026年8月14日(金)

休業期間中いただいたお問い合わせは、2026年8月17日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2026-04-27',
          // 説明タイトル3
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
ゴールデンウィーク休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2026年5月2日(土) ～ 2026年5月6日(水)

休業期間中いただいたお問い合わせは、営業開始日以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2025-12-22',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2025年12月29日(月) ～ 2026年1月4日(日)

休業期間中いただいたお問い合わせは、2026年1月5日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2025-08-05',
          // 説明タイトル3
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2025年8月12日(火) ～ 2025年8月15日(金)

休業期間中いただいたお問い合わせは、2025年8月18日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2025-07-17',
          // 説明タイトル3
          descriptiontitle: 'コニーシステムが制作したホームページのご紹介',
          // 説明文3
          description: `
コニーシステム制作のホームページをご紹介します
徳島大学大学院 医歯薬学研究部 口腔顎顔面補綴学分野様のホームページを当社にてリニューアルさせていただきました。

本サイトでは、InstagramやYouTubeとの連携を活用し、研究内容やイベント情報を通じて、分野の魅力を広く発信されています。
今回のリニューアルでは、先生方ご自身が積極的に情報発信できる体制を目指し、CMS（コンテンツ管理システム）を導入しました。
記事の移行も先生方ご自身でご対応いただいたことで、大幅なコスト削減が実現しました。
コニーシステムでは、CMSを用いたサイトに対し、セキュリティ面でも万全の体制で運用サポートを提供しております。

学術機関・企業のホームページ制作も承ります
当社では、大学・研究機関・企業など、さまざまな分野のホームページ制作に対応しています。
また、新規の制作だけでなく、他社で構築されたサイトの運用・保守や、スポットでのセキュリティ強化なども、リーズナブルな価格でご提供しております。
ご予算やご要望に応じて柔軟に対応いたしますので、まずはお気軽にお問合せ下さい。<a href="https://www.konniesystem.co.jp/Contact" title="お問い合わせ先はこちら">お問い合わせ先はこちら</a>
`,
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: '「徳島大学大学院 医歯薬学研究部 口腔顎顔面補綴学分野」様ホームページへ',
              icon: 'mdi-arrow-right-bold',
              href: 'https://www.t-hotetsu.jp/'
            }
          ]
        },
        {
          date: '2025-04-18',
          // 説明タイトル3
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
ゴールデンウィーク休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2025年5月3日(土) ～ 2025年5月6日(火)

休業期間中いただいたお問い合わせは、営業開始日以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2025-04-03',
          // 説明タイトル3
          descriptiontitle: 'UMIN設立35・30周年、おめでとうございます。',
          // 説明文3
          description: `
弊社では2011年より、PLAZA、SQUARE、演題登録システムをはじめとするUMINシステムを活用し、多くの学会サイトや医局ホームページの制作・保守運用を手がけてまいりました。
長年にわたる開発・運用に尽力されてきたUMIN関係者の皆様には、心より感謝申し上げます。
このたびはUMIN設立35・30周年、おめでとうございます。今後ますますのご発展をお祈り申し上げます。`,
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: 'コニーシステムFaceBook記事へ',
              icon: 'mdi-arrow-right-bold',
              href: 'https://www.facebook.com/konniesystem/'
            }
          ]
        },
        {
          date: '2024-12-04',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2024年12月28日(土) ～ 2025年1月5日(日)

休業期間中いただいたお問い合わせは、2025年1月6日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2024-07-24',
          // 説明タイトル3
          descriptiontitle: 'Joomla 5へのアップデートについて',
          // 説明文3
          description: `
2023年8月17日 で Joomla 3のサポートが終了したため、Joomla 3のまま運用し続けることはセキュリティリスクを伴いますので、早急にJoomla 4または5へ移行する必要があります。

Joomla 4やJoomla 5では大きな構造変更があり、それまでサポートされていたテンプレートやエクステンションが多数サポートされなくなるため、サイトの構成によって移行に非常に手間がかかる場合がございます。
弊社では2023年度にJoomlaで構築された13サイトの移行を行いましたが、テンプレートが未サポートとなったサイトが９サイト、使用しているエクステンションが未サポートとなったサイトが13サイトととなりましたので、代替のテンプレートやエクステンションを用いて、レイアウトや機能をできるだけ維持できるものを調査し、カスタマイズすることで対応いたしました。また、お客様のご要望によりエクステンションの独自開発も行いました。これら多数の移行の経験から適切なアドバイスや対応が可能となると思いますので、詳細につきましては、お気軽にお問い合わせください。

コニーシステムでは、企業、国立大学医学部、国立大学病院様の独自開発したシステムやサーバーの保守を多数行っており、毎年サーバーのセキュリティ診断を受けその都度対応しております。オープンソース製品のセキュリティ対策や、サーバー保守につきましても、お気軽にお問い合わせいただけたらと思います。`
        },
        {
          date: '2024-07-23',
          // 説明タイトル3
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2024年8月13日(火) ～ 2024年8月16日(金)

休業期間中いただいたお問い合わせは、2024年8月19日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2024-04-25',
          // 説明タイトル3
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
ゴールデンウィーク休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2024年4月27日(土) ～ 2024年4月29日(月)、2024年5月3日(金) ～ 2024年5月6日(月)

休業期間中いただいたお問い合わせは、営業開始日以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2023-12-15',
          // 説明タイトル3
          descriptiontitle: '「岩﨑胃腸科・内科」様ホームページ作成、公開のご案内',
          // 説明文3
          description: `
「岩﨑胃腸科・内科」様のホームページを作成させていただきました。
`,
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: '「岩﨑胃腸科・内科」様ホームページへ',
              icon: 'mdi-arrow-right-bold',
              href: 'https://iwasaki-ichouka-naika.or.jp/'
            }
          ]
        },
        {
          date: '2023-12-12',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2023年12月29日(金) ～ 2024年1月3日(水)

休業期間中いただいたお問い合わせは、2024年1月4日(木)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2023-07-21',
          // 説明タイトル3
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2023年8月11日(金) ～ 2023年8月15日(火)

休業期間中いただいたお問い合わせは、2023年8月16日(水)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2023-04-21',
          // 説明タイトル3
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
ゴールデンウィーク休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2023年4月29日(土) ～ 2023年5月7日(日)

休業期間中いただいたお問い合わせは、2023年5月8日(月)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2022-11-30',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○冬季休業日：2022年12月28日(水曜日) ～ 2023年1月4日(水曜日)

休業期間中いただきましたお問い合わせにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2022-11-17',
          // 説明タイトル
          descriptiontitle: '学会サポートページの実績 ホームページ紹介欄を更新いたしました。',
          // 説明文
          description: `
実績、ホームページ紹介欄に
「第15回日本医療マネジメント学会大阪支部学術集会」様をリンク掲載させていただきました。
`,
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: '学会サポートページ/ホームページ紹介へ',
              icon: 'mdi-arrow-right-bold',
              href: '/Service/supportConference#support-site'
            }
          ]
        },
        {
          date: '2022-09-15',
          // 説明タイトル3
          descriptiontitle: '研究開発のページを更新いたしました。',
          // 説明文3
          description: `
`,
          hasButton: 'true',
          // ボタンの内容
          button: [
            {
              text: '研究開発ページへ',
              icon: 'mdi-arrow-right-bold',
              href: '/Service/Investigation'
            }
          ]
        },
        {
          date: '2022-08-02',
          // 説明タイトル3
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○夏季休業日：2022年月8月11日（木曜日）～2022年8月15日（月曜日）

休業期間中にいただきましたお問合せにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2022-04-14',
          // 説明タイトル3
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
ゴールデンウィーク休業日につきまして下記の通りお知らせいたします。

○休業期間 ： 2022年4月29日(金) ～ 2022年5月5日(木)

休業期間中いただいたお問い合わせは、2022年5月6日(金)以降に回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          date: '2021-11-24',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○冬季休業日：2021年12月29日(水曜日) ～ 2022年1月3日(月曜日)

休業期間中いただきましたお問い合わせにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          // 日付
          date: '2021-07-20',
          // 説明タイトル
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○夏季休業日：2021年月8月12日（木曜日）～2021年8月16日（月曜日）

休業期間中にいただきましたお問合せにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          // 日付
          date: '2021-04-27',
          // 説明タイトル2
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文2
          description: `
休業期間 ： 2021年4月29日(木) ～ 2021年5月5日(水)
休業期間中いただいたお問い合わせは、2021年5月6日(木)以降に回答させていただきます。`
        },
        {
          date: '2020-12-11',
          // 説明タイトル3
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文3
          description: `
平素よりご愛顧いただき誠にありがとうございます。
冬季休業日につきまして下記の通りお知らせいたします。

○冬季休業日：2020年12月28日(月曜日) ～ 2021年1月4日(月曜日)

休業期間中いただきましたお問い合わせにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          // 日付
          date: '2020-07-29',
          // 説明タイトル4
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文4
          description: `
平素よりご愛顧いただき誠にありがとうございます。
夏季休業日につきまして下記の通りお知らせいたします。

○夏季休業日：2020年月8月8日（土曜日）～2020年8月16日（日曜日）

休業期間中にいただきましたお問合せにつきましては、営業開始日以降に順次回答させていただきます。
ご不便をおかけいたしますが、何卒、ご理解のほどお願い申し上げます。`
        },
        {
          // 日付
          date: '2020-04-22',
          // 説明タイトル5
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文5
          description: `
新型コロナウイルスの感染拡大防止のため 2020年4月28日(火) ～ 2020年5月6日(水)を休業とさせていただきます。
休業期間中いただいたお問い合わせは、2020年5月7日(木)以降に回答させていただきます。
ご了承いただけますようお願い申し上げます。`
        },
        {
          // 日付
          date: '2019-11-21',
          // 説明タイトル5
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2019年12月28日(土) ～ 2020年1月5日(日)
休業期間中いただいたお問い合わせは、2020年1月6日(月)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2019-07-24',
          // 説明タイトル5
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2019年8月13日(火) ～ 2019年8月16日(金)
休業期間中いただいたお問い合わせは、2019年8月19日(月)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2019-04-07',
          // 説明タイトル5
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2019年4月27日(土) ～ 2019年5月6日(月)
休業期間中いただいたお問い合わせは、2019年5月7日(火)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2018-12-10',
          // 説明タイトル5
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2018年12月28日(金) ～ 2019年1月6日(日)
休業期間中いただいたお問い合わせは、2019年1月7日(月)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2018-08-03',
          // 説明タイトル
          descriptiontitle: '夏季休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2018年8月13日(月) ～ 2018年8月16日(木)
休業期間中いただいたお問い合わせは、2018年8月17日(金)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2018-04-21',
          // 説明タイトル
          descriptiontitle: 'ゴールデンウィーク休業のお知らせ',
          // 説明文5
          description: `
休業期間 ： 2018年4月28日(土) ～ 2018年5月6日(日)
休業期間中いただいたお問い合わせは、2018年5月7日(月)以降に回答させていただきます。`
        },
        {
          // 日付
          date: '2017-12-15',
          // 説明タイトル
          descriptiontitle: '冬季休業のお知らせ',
          // 説明文5
          description: `
冬季休業期間 ： 2017年12月29日(金) ～ 2018年1月4日(木)
休業期間中いただいたお問い合わせは、2018年1月5日(金)以降に回答させていただきます。`
        }
      ],
      methods: {
        open () {
          const url = '/demo'
          window.open(url, '_blank')
        }
      }
      // mounted () {
      //   this.$nextTick(function () {
      //     if (this.hash) {
      //       const refName = this.hash.replace('#', '')
      //       this.scrollToAnchorPoint(refName)
      //     }
      //   })
      // },
      // methods: {
      //   scrollToAnchorPoint (refName) {
      //     const el = this.$refs[refName]
      //     el.scrollIntoView({ behavior: 'smooth' })
      //   }
    }
  }
}
</script>
